// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"3eba7643","512":"5aaf2c2c","549":"4f73e096","725":"1a470b12","781":"0fb09944"}[chunkId] + ".chunk.js";
};